import { GameServices } from '../services/game-services';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { GameBoardView } from '../interface/game-board/game-board-view';
import { GameBoardViewModel } from '../interface/game-board/game-board-view-model';
import { TwentyOneMainScene } from '../scenes/twentyone-main-scene';

export class SceneController {
  private readonly gameBoardViewModel: GameBoardViewModel;
  private gameBoardView?: GameBoardView;

  constructor(private readonly gameServices: GameServices) {
    this.gameBoardViewModel = new GameBoardViewModel(gameServices);
  }

  public initGraphics(scene: TwentyOneMainScene) {
    this.gameBoardView = new GameBoardView(scene, 0, 0, this.gameBoardViewModel);
    this.onResize(scene.currentGameSizeMetrics);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.gameBoardView?.onResize(gameSizeMetrics);
  }

  public onSceneReady() {
    this.gameServices.gameListener.onGameLoaded();
  }

  public showStartButton(showButton: boolean): void {
    this.gameBoardViewModel.showStartButton(showButton);
  }

  public startRemoteRound(moves: string[], logicVersion: number, logicSeed?: number): void {
    if (this.gameServices.useLocalDealer) {
      this.gameServices.twentyOneGameRunner.startNewLocalRound(logicVersion, logicSeed);
      return;
    }

    if (moves.length > 0) {
      this.gameServices.twentyOneGameRunner.startExistingRemoteRound(moves, logicVersion);
      return;
    }
    this.gameServices.twentyOneGameRunner.startNewRemoteRound(logicVersion);
  }

  public autoStartGame(): void {
    this.gameServices.gameListener.onStartGame();
  }

  public resetGameScene(): void {
    this.gameBoardViewModel.resetGameScene();
    this.gameServices.twentyOneGameRunner.currentGame?.resetGame();
  }
}
